import React, { ReactNode } from 'react';
import {
  Control,
  FieldError,
  FieldValues,
  Path,
  useController,
} from 'react-hook-form';
import { IconButton, IconButtonProps, TextField } from '@rossum/ui/material';

const ControlledValidationInput = <T extends FieldValues>({
  clearValidationsOnChange,
  control,
  dataCy,
  disabled,
  getErrorMessage,
  placeholder,
  name,
  rightIcon,
  rightIconProps,
  type,
  autoComplete,
}: {
  control: Control<T>;
  getErrorMessage: (
    _id: string,
    _errorMessage: FieldError
  ) => string | undefined;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  name: Path<T>;
  maxLength?: number;
  dataCy?: string;
  type?: 'text' | 'password';
  rightIcon?: ReactNode;
  rightIconProps?: IconButtonProps & { 'data-cy'?: string };
  clearValidationsOnChange?: (
    _onChange: (_event: React.ChangeEvent<unknown>) => void
  ) => (_event: React.ChangeEvent<unknown>) => void;
  autoComplete?: string;
}) => {
  const {
    field: { ref, value, onChange, onBlur },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <TextField
      slotProps={{
        htmlInput: { 'data-cy': dataCy },
        input: {
          endAdornment: (
            <IconButton {...rightIconProps} sx={{ scale: 0.7 }}>
              {rightIcon}
            </IconButton>
          ),
        },
      }}
      error={!!error}
      disabled={disabled}
      size="small"
      value={value}
      fullWidth
      type={type}
      placeholder={placeholder}
      onBlur={onBlur}
      onChange={
        clearValidationsOnChange ? clearValidationsOnChange(onChange) : onChange
      }
      inputRef={ref}
      helperText={error ? (getErrorMessage(name, error) ?? '') : ''}
      autoComplete={autoComplete}
    />
  );
};

export default ControlledValidationInput;
